"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SuburbanLinkBanner = require("./SuburbanLinkBanner");
Object.keys(_SuburbanLinkBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SuburbanLinkBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SuburbanLinkBanner[key];
    }
  });
});